import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import data from '../../data/index.json';
import { Section, SectionHeader, reveal } from '../../components';
import cohortImage from '../../assets/education.jpg';

const Internship = () => {
  const { t } = useTranslation();
  const { internships } = data;

  return (
    <Section id="internship" tone="paper">
      <SectionHeader
        index="08"
        label={t('Join the Ecosystem')}
        title={
          <>
            {t('Next-generation')} <em>{t('tech talent')}</em>
          </>
        }
        lede={t(internships.description)}
      />

      {/* The cohort itself — this section is about people, so lead with them. */}
      <motion.figure {...reveal()} className="mt-14 md:mt-20 group">
        <div className="overflow-hidden bg-paper-tint aspect-[16/9] md:aspect-[5/2]">
          <img
            src={cohortImage}
            alt={t('A Hyphen Tech education cohort at the end of a training session')}
            loading="lazy"
            className="img-editorial"
          />
        </div>
        <figcaption>
          {t('Hyphen Tech Education cohort — EducationUSA Burundi')}
        </figcaption>
      </motion.figure>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 mt-16 md:mt-24">

        {/* ── Process ── */}
        <div className="lg:col-span-7">
          <h3 className="label border-t border-[color:var(--rule)] pt-3">
            {t('The Growth Pipeline')}
          </h3>

          <ol className="mt-8">
            {internships.process.map((item, idx) => (
              <motion.li
                key={idx}
                {...reveal(idx)}
                className="grid grid-cols-[3rem_1fr] gap-4 md:gap-6 py-7 border-b border-[color:var(--rule)] first:border-t first:border-[color:var(--rule)]"
              >
                <span className="display-3 tabular text-gold-ink leading-none pt-1">
                  {String(item.step).padStart(2, '0')}
                </span>
                <div>
                  <h4 className="display-3">{t(item.title)}</h4>
                  <p className="mt-2 text-[0.9375rem] leading-relaxed text-ink-soft max-w-measure">
                    {t(item.desc)}
                  </p>
                </div>
              </motion.li>
            ))}
          </ol>
        </div>

        {/* ── Voices ── */}
        <div className="lg:col-span-5">
          <h3 className="label border-t border-[color:var(--rule)] pt-3">
            {t('Impact Stories')}
          </h3>

          <div className="mt-8 space-y-10">
            {internships.successStories.map((story, idx) => (
              <motion.blockquote key={idx} {...reveal(idx)} className="rule-gold pt-6">
                <p className="font-heading text-xl md:text-[1.375rem] leading-[1.45] text-ink">
                  &ldquo;{t(story.story)}&rdquo;
                </p>
                <footer className="mt-5 flex items-baseline gap-3">
                  <cite className="not-italic text-sm font-semibold text-ink">
                    {story.name}
                  </cite>
                  <span className="label">{t(story.role)}</span>
                </footer>
              </motion.blockquote>
            ))}

            <motion.div {...reveal()} className="bg-paper-warm p-8">
              <span className="label label-accent">
                {t('Applications are currently open')}
              </span>
              <h4 className="display-2 mt-4">
                {t('Forge your technical path')}
              </h4>
              <p className="mt-4 text-[0.9375rem] leading-relaxed text-ink-soft">
                {t('We review applications on a rolling basis and will contact shortlisted candidates directly.')}
              </p>
              <a href="#contact" className="btn btn-solid mt-6">
                {t('Get In Touch')}
              </a>
            </motion.div>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default Internship;
